var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "data-mrf-recirculation": "Listado de Noticias" } },
    [
      _vm._l(_vm.items, function (item) {
        return _c("agency-card", { key: item.id, attrs: { item: item } })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.enabled,
              expression: "enabled",
            },
          ],
          staticClass: "title-section defaultSect",
          on: { click: _vm.getItems },
        },
        [_vm._m(0)]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", { staticClass: "heading-title-sect text-center" }, [
      _c("span", [_vm._v("Más Central de Agencias")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }